import { render, staticRenderFns } from "./JournalPicker.vue?vue&type=template&id=331f1204&"
import script from "./JournalPicker.vue?vue&type=script&lang=js&"
export * from "./JournalPicker.vue?vue&type=script&lang=js&"
import style0 from "./JournalPicker.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports